import { AuthServiceApi } from 'api/AuthServiceApi';
import { authClient } from 'container/authClient';

export const authServiceApi = new AuthServiceApi(authClient);
